<template>
  <div class="modal" :class="{'is-active': opened}">
    <div class="modal-background"></div>
    <div class="modal-card my-modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Create PO Bills</p>
        <button class="delete" @click="close"></button>
      </header>
      <section class="modal-card-body">
        <table class="table is-fullwidth">
          <thead>
            <tr>
              <th>#</th>
              <th>Ref number</th>
              <th>PO</th>
              <th>Container</th>
              <th>Date</th>
              <th>Amount</th>
              <th>Result</th>
              <th>NS Bill</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(b, j) in poBills" :key="'p-b-'+j">
              <td>{{j+1}}</td>
              <td>
                <input class="input" v-model="b.key" :class="{'is-danger': !Boolean(b.key)}" type="text" :readonly="waiting">
              </td>
              <td>{{b.po.tranId}}</td>
              <td>{{b.container}}</td>
              <td>
                <input class="input" v-model="b.date" :class="{'is-danger': !validDate(b.date)}" type="text" placeholder="YYYY-MM-DD" :readonly="waiting">
              </td>
              <td>{{formatPrice(b.amount)}}</td>
              <td>
                <span class="tag" :class="{'is-warning': b.result.startsWith('Creating'), 'is-success': b.result.startsWith('Succeeded'), 'is-danger': b.result.startsWith('Failed')}">
                  {{b.result}}
                </span>
              </td>
              <td>{{b.nsBill}}</td>
            </tr>
          </tbody>
        </table>
        <div v-if="error" class="notification is-danger is-light">
          <button class="delete" @click="error=''"></button>
          {{error}}
        </div>
      </section>
      <footer class="modal-card-foot">
        <a v-if="!done" class="button is-link" :class="{'is-loading': waiting}" :disabled="!valid" @click="createPoBills">Create PO Bills</a>
        <a v-if="!done" class="button" @click="close">Cancel</a>
        <a v-if="done" class="button" @click="close">Close</a>
      </footer>
    </div>
  </div>
</template>
  
<script>

export default {
  name: 'create-po-bills-modal',
  props: ['opened', 'inbound'],
  data () {
    return {
      error: '',
      waiting: false,
      poBills: [],
      done: false,
    }
  },
  computed: {
    server () {
      return this.$store.state.config.server
    },
    valid () {
      if (!this.poBills.length) {
        return false
      }
      for (var b of this.poBills) {
        if (!b.key || !b.date || !this.validDate(b.date)) {
          return false
        }
      }
      return true
    },
    dateValid () {
      return !this.newExpectedShippingDate || this.validDate(this.newExpectedShippingDate)
    },
    invoiceNumMap () {
      var result = {}
      for (var i of this.inbound.invoiceNums) {
        result[i.container] = i.invoiceNum
      }
      return result
    },
  },
  watch: {
    opened: function (val) {
      if (val && this.inbound) {
        this.makePoBills()
      }
    }
  },
  methods: {
    close () {
      this.$emit('closeCreatePoBillsModal', false)
    },
    validDate (s) {
      return /^\d{4}-\d{2}-\d{2}$/.test(s)
    },
    makeInvoiceMap () {
      
    },
    makePoBills () {
      var poBillsMap = {}
      var invoiceNumMap = this.invoiceNumMap
      var items = this.inbound.items.map(item => {
        var newItem = JSON.parse(JSON.stringify(item))
        var cc = item.containerInfo.split(',')
        var cq = {}
        for (var c of cc) {
          var ss = c.trim().split('(')
          var c = ss[0].trim()
          var qty = parseInt(ss[1].replaceAll(')', '').trim())
          if (!cq[c]) {
            cq[c] = 0
          }
          cq[c] += qty
        }
        var parts = []
        for (var c in cq) {
          parts.push(c + '(' + cq[c] + ')')
        }
        newItem.containerInfo = parts.join(', ')
        return newItem
      })
      items.forEach((item, index) => {
        var cc = item.containerInfo.split(',')
        for (var c of cc) {
          var ss = c.trim().split('(')
          var c = ss[0].trim()
          var qty = parseInt(ss[1].replaceAll(')', '').trim())
          var invoiceNum = this.invoiceNumMap[c] || ''
          var key = invoiceNum + '-' + item.po.tranId.substring(2) + '-' + c
          var poBill = poBillsMap[key]
          if (!poBill) {
            poBill = {
              key: key,
              poId: item.poId,
              po: item.po,
              container: c,
              items: [],
              date: this.inbound.actualShippingDate,
              nsBill: {},
              amount: 0,
              result: 'Pending',
            }
            poBillsMap[key] = poBill
          }
          var amount = qty * item.poItem.rate
          poBill.amount += amount
          poBill.items.push({
            inboundItem: item,
            inboundItemIndex: index,
            qty: qty,
          })
        }
        console.log(poBillsMap)
        this.poBills = Object.values(poBillsMap)
      })
    },
    createPoBills () {
      if (this.waiting || !this.valid) {
        return
      }
      this.createPoBill(0)
    },
    createPoBill(index) {
      this.waiting = true
      var poBill = this.poBills[index]
      var message = {
        inboundId: this.inbound.id,
        refNum: poBill.key,
        poId: poBill.poId,
        container: poBill.container,
        date: poBill.date,
        amount: poBill.amount,
        items: poBill.items.map(item => {
          return {
            inboundItemId: item.inboundItem.id,
            itemId: item.inboundItem.itemId,
            poLine: item.inboundItem.poLine,
            shipmentItemName: item.inboundItem.shipmentItemName,
            shipmentItemDescription: item.inboundItem.shipmentItemDescription,
            shipmentItemId: item.inboundItem.shipmentItemId,
            quantity: item.qty,
            inboundItemIndex: item.inboundItemIndex,
          }
        })
      }
      poBill.result = 'Creating...'
      this.$http.post(this.server + '/myapp/create-po-bill/', message).then(resp => {
        poBill.result = 'Succeeded'
        poBill.nsBill = resp.body
        if (index + 1 < this.poBills.length) {
          this.createPoBill(index + 1)
        } else {
          this.waiting = false
          this.done = true
          this.$emit('PoBillsCreated')
        }
      }, err => {
        poBill.result = 'Failed'
        if (index + 1 < this.poBills.length) {
          this.createPoBill(index + 1)
        } else {
          this.waiting = false
          this.done = true
          this.$emit('PoBillsCreated')
        }
      })
    },
    formatPrice (value) {
      if (!value) {
        return ''
      }
      return '$' + value.toLocaleString('en-US', {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
        useGrouping: false
      })
    },
  },
}
</script>

<style scoped>
.my-modal-card {
  width: 80%!important;
}
</style>